import { AudienceForMembershipFilter, Audience_Status } from '@occc/graphql';
import { AUDIENCE_STATUS_ALL } from '@occc-app/routes/Audience/constants';
import { StatusType } from '@occc-app/routes/Audience/types';

export const getAudienceFilter = (
  membershipId: string,
  status: StatusType,
): AudienceForMembershipFilter => {
  if (status === undefined) {
    return {
      membershipIdEquals: membershipId,
      statusContains: [Audience_Status.Active],
    };
  }

  return {
    membershipIdEquals: membershipId,
    statusEquals: status !== AUDIENCE_STATUS_ALL ? status : undefined,
  };
};
